// extracted by mini-css-extract-plugin
export default {"value1":"ReportSidebar_value1__tlLPz","svgStyle":"ReportSidebar_svgStyle__T-rx0"};